import { BCMSRecord, DisabledPrompt, useBCMSContext, useModel, useStateManager, useWorkflow } from "@bcm-dev/bcms-vite";
import { CenterContentContainer, ContentHeaderView, FormContainer, PageContainer, PageContentView } from "components/shared";
import { FormButtonRow } from "components/shared/containers/FormContainer";
import { UIButton } from "components/ui";
import Classes from "model";
import React from "react";
import "./styles.css"
import { ImageAsset } from "res";

/**
 * @function SoftTokensActivateTokenInfoPage
 * @return {React.Component}
 * @exported true
 * @description The main component for SoftTokensActivateTokenInfoPage.
 */
export default function SoftTokensActivateTokenInfoPage(props) { 
    const { nextStep } = useWorkflow() ?? {};
    const model = useModel();
    const globalController = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, globalController);
    const data = { ...getDefaultData(model), ...props.data ?? {} };
    const ui = { ...getDefaultUI(), ...props.ui ?? {} };

    const controller = (state, setState) => ({
        data: state.data,
        ui: state.ui,
        gotToNextStep: () => {
            nextStep();
        }
    });

    return (
        <PageContainer className="soft-tokens-activate-token-info-page" state={ { data, ui } } controller={ controller }>
            <PageContent/>
        </PageContainer>
    );
}

export const getDefaultData = () => ({
    // no data for now.
});

export const getDefaultUI = () => ({
    // no ui changes for now.
});

function PageContent() {
    const { gotToNextStep } = useStateManager();

    return (
        <PageContentView>
            <CenterContentContainer>
                <ContentHeaderView text="Activate Token" />
                <p className="subtitle text-section">What is it?</p>
                <p className="text-section">
                    In order to make your online banking and mobile banking experience as secure as possible, 
                    we are introducing an additional measure of identity verification.
                </p>
                <p className="subtitle text-section">How does it work?</p>
                <p className="text-section">
                    In addition to providing your login credentials when signing into online banking, you will 
                    also be asked to provide a security code which is sent to your mobile device. When performing 
                    transactions, making profile changes, or logging in, you may be asked to verify your identity further.
                </p>
                <p className="subtitle text-section">Next steps</p>
                <p className="text-section">
                    In order to register and use your mobile device for soft tokens, you will need to download 
                    and install the DIGIPASS app.
                </p>
                <p className="subtitle text-section">iPhone users</p>
                <p className="text-section">
                    Scan the QR code or follow the link to download the DIGIPASS app.
                </p>
                <div className="flex-container flex-horizontal qr-code-container">
                    <div className="flex-container flex-vertical align-center">
                        <ImageAsset id="AppleQRCodeIcon" className="qr-code-image" data-point="Soft_Tokens_Activate_Token_Page_Apple_QR_Code_Icon" />
                        <DisabledPrompt>
                            <ImageAsset id="AppStoreDownloadIcon" className="download-image clickable" data-point="Soft_Tokens_Activate_Token_Page_App_Store_Download_Icon" />
                        </DisabledPrompt>
                    </div>
                </div>
                <p className="subtitle text-section">Android users</p>
                <p className="text-section">
                    Scan the QR code or follow the link to download the DIGIPASS app.
                </p>
                <div className="flex-container flex-horizontal qr-code-container">
                    <div className="flex-container flex-vertical align-center">
                        <ImageAsset id="GoogleQRCodeIcon" className="qr-code-image" data-point="Soft_Tokens_Activate_Token_Page_Google_QR_Code_Icon" />
                        <DisabledPrompt>
                            <ImageAsset id="GooglePlayStoreDownloadIcon" className="download-image clickable" data-point="Soft_Tokens_Activate_Token_Page_Google_Play_Store_Download_Icon" />
                        </DisabledPrompt>
                    </div>
                </div>
                <FormContainer className="small-form-width">
                    <FormButtonRow>
                        <UIButton className="secondary-button" text="Cancel" dataPoint="Soft_Tokens_Activate_Token_Page_Cancel_Button" />
                        <UIButton className="primary-button" text="Continue" dataPoint="Soft_Tokens_Activate_Token_Page_Continue_Button" onClick={ gotToNextStep } />
                    </FormButtonRow>
                </FormContainer>
            </CenterContentContainer>
        </PageContentView>
    );
}
